/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type SignatureTemplateConfigPhotoSide = typeof SignatureTemplateConfigPhotoSide[keyof typeof SignatureTemplateConfigPhotoSide];


export const SignatureTemplateConfigPhotoSide = {
  left: 'left',
  right: 'right',
} as const;
